import type { JSX } from 'solid-js';
import { RepositoryModelTree } from './RepositoryModelTree';
import type { ModelTreeProps } from './ModelTree.types';

export type { ModelTreeProps } from './ModelTree.types';

export const ModelTree = (props: ModelTreeProps): JSX.Element => (
  <RepositoryModelTree {...props} />
);
